module.exports = __webpack_public_path__ + "img/mx.33ab385.png";